import { useState, useEffect } from 'react';
import DC from '../../common/DataConnector'
import { useParams } from 'react-router-dom';
import ScrollToTop from '../../components/ScrollToTop';
import { actLoading, actLoadingEnd } from '../../store/Actions';
import { useAppDispatch } from '../../store/hooks';

export default function PageDefault()
{
    const dispatch = useAppDispatch()
    const { pageCode } = useParams()
    const [content, setContent] = useState<any>({ subtitle: '', title: '', items: [] })

    useEffect(() =>
    {
        (async function ()
        {
            actLoading(dispatch)
            const result = await DC.Get('/customer/page/' + pageCode);
            if (result.wasOk) {
                if (result.data.items)
                    result.data.items = JSON.parse(result.data.items);
                else
                    result.data.items = [];
                setContent(result.data);
            }
            actLoadingEnd(dispatch)
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageCode]);

    function renderItemText(text: string, index: number)
    {
        const values = text.split('|');
        if (values.length === 1)
            return <p key={index}>{text}</p>

        switch (values[0]) {
            case 'link':
                return <p key={index}>
                    <a href={values[2]} target="_blank" rel="noopener noreferrer">{values[1]}</a>
                </p>
            case 'image':
            case 'img':
                return <p key={index}>
                    <img src={values[2]} alt={values[1]} />
                </p>
            default:
                return <p key={index}>{text}</p>
        }
    }

    function renderItem(item: any, index: number)
    {
        switch (item.type) {
            case "title":
                return <h3 className="page-legal-title" key={index}>{item.value}</h3>
            case "subtitle":
                return <h4 className="page-legal-subtitle" key={index}>{item.value}</h4>
            case "texts":
                const items = item.value ? item.value.split('\n') : [];
                return <div className="page-legal-text" key={index}>
                    {items.map((text: string, indexText: number) => (
                        renderItemText(text, indexText)
                    ))}
                </div>
            case "image":
            case "img":
                return <img className="page-content-img" src={item.image} alt="" key={index} />
            default:
                return null;
        }
    }

    return (
        <div>
            <ScrollToTop />
            <div className="page">
                <div className="page-title">
                    <h2>{content.title}</h2>
                </div>
                <div className="page-content">
                    {content.items.map((item: any, index: number) => (
                        renderItem(item, index)
                    ))}
                </div>
            </div>
        </div>
    )
}